
import React from 'react';
import { NavBar } from '@/components/navbar';
import CreateFakeBusiness from '@/components/tools/CreateFakeBusiness';

const FakeBusinessCreator = () => {
  return (
    <div className="min-h-screen bg-brand-light flex flex-col">
      <NavBar />
      <div className="container mx-auto px-4 pt-6 pb-8 bg-brand-light flex-1">
        <div className="mb-4">
          <h1 className="text-2xl font-bold">Developer Tools</h1>
          <p className="text-gray-600">Create test businesses for development purposes</p>
        </div>
        
        <div className="mb-8">
          <CreateFakeBusiness />
        </div>
      </div>
    </div>
  );
};

export default FakeBusinessCreator;
